import { createComponent } from '@front/utils/alpine';
import Cookies from 'js-cookie';
const New = createComponent(() => ({
    isOpen: false,
    initCookie() {
        if (!Cookies.get('newcom_new')) {
            this.isOpen = true;
        }
    },
    setCookie() {
        Cookies.set('newcom_new', 'showed', {
            expires: 30,
            sameSite: 'strict',
        });
        this.isOpen = false;
    },
}));
export { New };
